import React from "react";
import { Link } from "react-router-dom";
import { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import Tooltip from "@mui/material/Tooltip";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import ListItemAvatar from "@mui/material/ListItemAvatar";
import Avatar from "@mui/material/Avatar";
import ImageIcon from "@mui/icons-material/Image";
import WorkIcon from "@mui/icons-material/Work";
import BeachAccessIcon from "@mui/icons-material/BeachAccess";
import Divider from "@mui/material/Divider";
import NotificationsIcon from "@mui/icons-material/Notifications";
import MenuRoundedIcon from "@mui/icons-material/MenuRounded";
import Badge from "@mui/material/Badge";
import Modal from "@mui/material/Modal";
import Backdrop from "@mui/material/Backdrop";

import "./Navbarlogedin.css";
import Bookmark from "./popups/Bookmark";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

const Navbarlogedin = () => {
  let navigate = useNavigate();
  const location = useLocation();
  const [isOpen, setIsOpen] = useState(false);

  const handlePopupOpen = () => {
    setIsOpen(true);
  };
  const handlePopupClose = () => {
    setIsOpen(false);
  };

  // Profile Dropdown
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [anchorEl2, setAnchorEl2] = React.useState(null);
  const open = Boolean(anchorEl);
  const [anchorNt, setAnchorNt] = React.useState(null);
  const openNt = Boolean(anchorNt);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleNtClick = (event) => {
    setAnchorNt(event.currentTarget);
  };
  const handleNtClose = () => {
    setAnchorNt(null);
  };
  const loggingOut=()=>{
    localStorage.removeItem("isAuthenticated");
  }
  return (
    <>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={isOpen}
        onClose={handlePopupClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <div className="flex justify-center h-full">
          <Bookmark />
        </div>
      </Modal>
      <div className="navbarlogedin flex">
        <div className="logo">
          <Link to="/">
            <h1 className="text-2xl font-medium">interwiu.com</h1>
          </Link>
        </div>
        <>
          <ul className="nav-list flex">
            <li className="nav-item">
              <Link to="/">
                <p>Find an Interviewer</p>
              </Link>
            </li>
            <li className="nav-item">
              <Link to="/sent-requests">
                <p>Sent Requests</p>
              </Link>
            </li>
            <li className="nav-item">
              <Link to="/accepted-requests">
                <p className="flex">
                  Accepted Requests <div className="notify"></div>
                </p>
              </Link>
            </li>
            <li className="nav-item">
              <Link to="/upcoming-interviews">
                <p>Upcoming Interviews</p>
              </Link>
            </li>
            <li className="nav-item">
              <Link to="/completed-interviews">
                <p className="flex">
                  Completed Interviews <div className="notify"></div>
                </p>
              </Link>
            </li>
          </ul>
          <div className="sidebar flex">
            {/* Notification Bell */}
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                textAlign: "center",
              }}
            >
              <Tooltip title="Notification">
                <Button
                  onClick={handleNtClick}
                  size="small"
                  sx={{ color: "black" }}
                  aria-controls={openNt ? "notification" : undefined}
                  aria-haspopup="true"
                  aria-expanded={openNt ? "true" : undefined}
                >
                  <div
                    className="notifier rounded w-full flex justify-center border hover:bg-slate-200"
                    style={{ height: "50px" }}
                  >
                    <Badge badgeContent={4} color="primary">
                      <NotificationsIcon color="action" />
                    </Badge>
                  </div>
                </Button>
              </Tooltip>
            </Box>
            <Menu
              anchorEl={anchorNt}
              id="Notification"
              open={openNt}
              onClose={handleNtClose}
              onClick={handleNtClose}
              PaperProps={{
                elevation: 0,
                sx: {
                  overflow: "visible",
                  filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
                  mt: 1,
                  px: 1,
                  width: 300,
                  borderRadius: 2,
                  "& .MuiAvatar-root": {
                    width: 32,
                    height: 32,
                    ml: -0.5,
                    mr: 1,
                  },
                  "&:before": {
                    content: '""',
                    display: "block",
                    position: "absolute",
                    top: 0,
                    right: 14,
                    width: 10,
                    height: 10,
                    bgcolor: "background.paper",
                    transform: "translateY(-50%) rotate(45deg)",
                    zIndex: 0,
                  },
                },
              }}
              transformOrigin={{ horizontal: "right", vertical: "top" }}
              anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
            >
              <List
                sx={{
                  width: "100%",
                  maxWidth: 360,
                  bgcolor: "background.paper",
                }}
                subheader={
                  <Typography
                    variant="h6"
                    component="h6"
                    sx={{
                      fontWeight: "bold",
                      marginLeft: "12px",
                    }}
                  >
                    Notifications
                  </Typography>
                }
              >
                <ListItem>
                  <ListItemAvatar>
                    <Avatar>
                      <ImageIcon />
                    </Avatar>
                  </ListItemAvatar>
                  <ListItemText
                    primary="John Doe"
                    secondary="You're meeting is accepted by John Doe"
                  />
                </ListItem>
                <Divider variant="inset" component="li" />
                <ListItem>
                  <ListItemAvatar>
                    <Avatar>
                      <WorkIcon />
                    </Avatar>
                  </ListItemAvatar>
                  <ListItemText primary="Work" secondary="Jan 7, 2014" />
                </ListItem>
                <Divider variant="inset" component="li" />
                <ListItem>
                  <ListItemAvatar>
                    <Avatar>
                      <BeachAccessIcon />
                    </Avatar>
                  </ListItemAvatar>
                  <ListItemText primary="Vacation" secondary="July 20, 2014" />
                </ListItem>
              </List>
            </Menu>

            {/* Profile Dropdown */}

            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                textAlign: "center",
              }}
            >
              <Tooltip title="My Profile">
                <Button
                  onClick={handleClick}
                  size="small"
                  sx={{ color: "black" }}
                  aria-controls={open ? "account-menu" : undefined}
                  aria-haspopup="true"
                  aria-expanded={open ? "true" : undefined}
                >
                  <div className="sidebar-profile px-2 rounded border cursor-pointer hover:bg-slate-200 flex">
                    <div className="sidebar-profile-img mx-1 flex">
                      <img src={require("../../images/photo.png")} alt="" />
                    </div>
                    <div
                      className="text-sm mx-1 flex"
                      style={{ flexDirection: "column" }}
                    >
                      <p>Me</p>
                      <i className="fa-solid fa-caret-down"></i>
                    </div>
                  </div>
                </Button>
              </Tooltip>
            </Box>
            <Menu
              anchorEl={anchorEl}
              id="account-menu"
              open={open}
              onClose={handleClose}
              onClick={handleClose}
              PaperProps={{
                elevation: 0,
                sx: {
                  overflow: "visible",
                  filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
                  mt: 1,
                  px: 1,
                  width: 300,
                  borderRadius: 2,
                  "& .MuiAvatar-root": {
                    width: 32,
                    height: 32,
                    ml: -0.5,
                    mr: 1,
                  },
                  "&:before": {
                    content: '""',
                    display: "block",
                    position: "absolute",
                    top: 0,
                    right: 14,
                    width: 10,
                    height: 10,
                    bgcolor: "background.paper",
                    transform: "translateY(-50%) rotate(45deg)",
                    zIndex: 0,
                  },
                },
              }}
              transformOrigin={{ horizontal: "right", vertical: "top" }}
              anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
            >
              <Typography>
                <div className=" profile-dropdown-head flex">
                  <div>
                    <img
                      src={require("../../images/photo.png")}
                      style={{
                        height: "60px",
                        width: "60px",
                        borderRadius: "50%",
                      }}
                      alt=""
                    />
                  </div>
                  <div>
                    <Typography
                      variant="h5"
                      component="h5"
                      sx={{ fontWeight: "bold" }}
                    >
                      John Doe
                    </Typography>
                    <p>B.Tech, IIT Kharagpur</p>
                  </div>
                </div>
              </Typography>
              <button
                type="button"
                className="cust-btn view-profile-btn"
                onClick={() => {
                  navigate("/dashboard");
                }}
              >
                View Profile
              </button>
              <Divider />
              <MenuItem id="dropdown-btn" onClick={handlePopupOpen}>
                <p>
                  <i className="fa-solid fa-bookmark w-5"></i> Bookmarks
                </p>
              </MenuItem>

              <MenuItem
                id="dropdown-btn"
                onClick={() => {
                  navigate("/declined-requests");
                }}
              >
                <p>
                  <i className="fa-solid fa-circle-xmark w-5"></i> Declined
                  Requests
                </p>
              </MenuItem>
              <MenuItem id="dropdown-btn">
                <p>
                  <i className="fa-solid fa-ban w-5"></i> Canceled Mock
                  Interviews
                </p>
              </MenuItem>
              <MenuItem
                id="dropdown-btn"
                onClick={() => {
                  navigate("/reschedule");
                }}
              >
                <p>
                  <i className="fa-solid fa-clock w-5"></i> Reschedule a Mock
                  Interview
                </p>
              </MenuItem>
              <MenuItem
                id="dropdown-btn"
                onClick={() => {
                  navigate("/s/cancel");
                }}
              >
                <p>
                  <img
                    src={require("../../images/cross.png")}
                    alt="cross"
                    style={{ width: "18px", display: "inline" }}
                  />{" "}
                  Cancel a Mock Interview
                </p>
              </MenuItem>
              <MenuItem
                id="dropdown-btn"
                onClick={() => {
                  navigate("/report-issue");
                }}
              >
                <p>
                  <i className="fa-solid fa-triangle-exclamation w-5"></i>{" "}
                  Report an Issue
                </p>
              </MenuItem>
              <MenuItem id="dropdown-btn">
                <p>
                  <i className="fa-solid fa-gear w-5"></i> Account Settings
                </p>
              </MenuItem>
              <hr />
              <form>
                <button
                  type="submit"
                  className="cust-btn logout-btn"
                  onClick={loggingOut}
                >
                  <i className="fa-solid fa-arrow-right-from-bracket"></i> Log
                  Out
                </button>
              </form>
            </Menu>
            <IconButton
              aria-label="more"
              className="navLoggedInDropdownIcon"
              id="long-button"
              aria-controls={Boolean(anchorEl2) ? "long-menu" : undefined}
              aria-expanded={Boolean(anchorEl2) ? "true" : undefined}
              aria-haspopup="true"
              onClick={(e) => setAnchorEl2(e.currentTarget)}
            >
              <MenuRoundedIcon />
            </IconButton>
            <Menu
              id="long-menu"
              className="navLoggedInDropdown"
              MenuListProps={{
                "aria-labelledby": "long-button",
              }}
              anchorEl={anchorEl2}
              open={Boolean(anchorEl2)}
              onClose={() => setAnchorEl2(null)}
            >
              <MenuItem>
                <Link to="/">
                  <p>Find an Interviewer</p>
                </Link>
              </MenuItem>
              <MenuItem>
                <Link to="/sent-requests">
                  <p>Sent Requests</p>
                </Link>
              </MenuItem>
              <MenuItem>
                <Link to="/upcoming-interviews">
                  <p>Upcoming Interviews</p>
                </Link>
              </MenuItem>
              <MenuItem>
                <Link to="/accepted-requests">
                  <p className="flex">
                    Accepted Requests <div className="notify"></div>
                  </p>
                </Link>
              </MenuItem>
              <MenuItem>
                <Link to="/completed-interviews">
                  <p className="flex">
                    Completed Interviews <div className="notify"></div>
                  </p>
                </Link>
              </MenuItem>
            </Menu>
          </div>
        </>
      </div>
    </>
  );
};

export default Navbarlogedin;
